import React, {useEffect, useState} from 'react';
import {Snackbar} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {createSelector} from 'reselect';
import {clearSnackbarInfo} from 'app/components/snackbar/SnackbarActions';
import {Button} from '@fupa/fupa-uikit';
import {useHistory} from 'react-router';
import {zIndexBackdrop} from 'app/styles/cssConstants';

const selectSnackbarInfo = createSelector(
  state => state.info,
  info => info
);

const FuPaSnackbar = props => {
  let history = useHistory();
  const dispatch = useDispatch();
  const {message, action} = useSelector(selectSnackbarInfo);

  const [open, setOpen] = useState(!!message);

  const closeSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(clearSnackbarInfo());
  };

  useEffect(() => {
    return () => {
      if (open) {
        dispatch(clearSnackbarInfo());
      }
    };
  }, [history.location.pathname, open]);

  useEffect(() => {
    const showSnackbar = !!message;
    setOpen(showSnackbar);
  }, [message]);

  const handleClick = () => {
    if (action.target === 'pwa') {
      history.push(action.link);
    } else {
      window.location.href = action.link;
    }
  };

  const buttonAction =
    action?.label && action?.link ? <Button text label={action.label} onClick={handleClick} /> : null;

  return (
    <Snackbar
      sx={theme => ({
        zIndex: zIndexBackdrop,
        [theme.breakpoints.down('lg')]: {
          bottom: 80,
        },
      })}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      open={open}
      onClose={closeSnackBar}
      autoHideDuration={6000}
      message={message}
      action={buttonAction}
      {...props}
    />
  );
};

export default FuPaSnackbar;
